import { render } from "./FavDeleteBtn.vue?vue&type=template&id=5db2aef6"
import script from "./FavDeleteBtn.vue?vue&type=script&lang=js"
export * from "./FavDeleteBtn.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__